import React, { useState } from "react";
import { Link } from "react-router";
import "./LatestCollections.css";
import { shopData } from "../../shopData";
import { useImageFade } from "../../hooks/useImageFade";
import ProductModal from "../ProductModal/ProductModal";
import { useCurrency } from "../../Context/CurrencyContext";

function CollectionItem({ item, onSelect }) {
  const images = item.images?.length > 0 ? item.images : [item.imageUrl];
  const activeIndex = useImageFade(images);
  const { getPrice } = useCurrency();

  return (
    <div className="collection-item" onClick={() => onSelect(item)}>
      <div className="collection-img-container">
        {images.map((src, idx) => (
          <img
            key={src}
            src={src}
            alt={item.name}
            className={`fade-image ${idx === activeIndex ? "active" : ""}`}
            loading="lazy"
            decoding="async"
          />
        ))}
      </div>
      <div className="collection-info">
        <h3>{item.name}</h3>
        <p>{getPrice(item)}</p>
      </div>
    </div>
  );
}

export default function LatestCollections() {
  const previewItems = shopData.slice(0, 3);
  const [selectedItem, setSelectedItem] = useState(null);

  return (
    <div className="latest-collections">
      <div className="latest-collections-header">
        <h6 className="small-header">Latest Collections</h6>
        <h2>Explore our newest arrivals and timeless classics.</h2>
      </div>
      <div className="latest-collections-grid">
        {previewItems.map((item) => (
          <CollectionItem
            key={item.id}
            item={item}
            onSelect={setSelectedItem}
          />
        ))}
      </div>
      <div className="latest-collections-btn-container">
        <Link to="/shop">
          <button className="more-btn">Explore more</button>
        </Link>
      </div>

      {selectedItem && (
        <ProductModal
          item={selectedItem}
          onClose={() => setSelectedItem(null)}
        />
      )}
    </div>
  );
}
